import type { RecommendationItem } from 'voyager';

import { crossSellRoutesByType, Routes } from '@common/constants';

export type SpaCrossSellObject = {
  id: number | string;
  name?: string;
  image?: { url?: string };
  price?: { amount: number; currencyCode: string } | null;
  durationText?: string;
};

export type SpaCrossSellEntry = { type: string; object: SpaCrossSellObject };

export type RecommendationTarget = { route: Routes; id: string };

export const mapSpaCrossSellToRecommendations = (
  items: SpaCrossSellEntry[],
  { fallbackImageUrl }: { fallbackImageUrl?: string } = {}
): { items: RecommendationItem[]; targets: Map<string, RecommendationTarget> } => {
  const targets = new Map<string, RecommendationTarget>();
  const recommendations = items.reduce<RecommendationItem[]>((acc, { type, object }) => {
    const route = crossSellRoutesByType[type];
    if (!object?.name || !route) {
      return acc;
    }
    const key = `${type}-${object.id}`;
    targets.set(key, { route, id: String(object.id) });
    acc.push({
      id: key,
      name: object.name,
      imageUrl: object.image?.url || fallbackImageUrl,
      price: object.price ?? null,
      meta: object.durationText,
    });
    return acc;
  }, []);

  return { items: recommendations, targets };
};
